import styled from 'styled-components';

import NavLink from 'components/NavLink';

export const matchMenuLinkStyle: React.CSSProperties = {
  backgroundColor: '#e6f7ff',
};

export const MenuLink = styled(NavLink)`
  align-items: center;
  background-color: transparent;
  color: rgb(0, 158, 176);
  display: flex;
  padding: 0.25rem 0.75rem;
  &:hover {
    background-color: #e6f7ff;
  }
`;

export const PopoverButton = styled('a')`
  color: inherit;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin-left: 1.25rem;
  min-width: 6.5rem;
  user-select: none;
`;

export const PopoverMenu = styled('ul')`
  background-color: white;
  border-radius: 10px;
  list-style-type: none;
  margin: 0;
  outline: none;
  overflow: hidden;
  padding: 0 !important;
`;

export const MenuItem = styled('li')`
  line-height: 2rem;
  text-align: ${(props) => props.theme.textAlign};
  transition-delay: 0s;
  transition-duration: 0.3s;
  transition-property: all;
  transition-timing-function: ease;
  white-space: nowrap;
  width: 100%;
  .icon {
    margin-inline-end: 0.5rem;
  }
`;

export const MenuDivider = styled('li')`
  background-color: #e8e8e8;
  height: 1px;
  line-height: 0;
  margin: 4px 0;
  overflow: hidden;
  width: 100%;
`;
